import { MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import { Outlet } from 'react-router'

import { MeetOurTeamBanner } from './MeetOurTeamBanner/MeetOurTeamBanner'
import { MeetOurTeamContent } from './MeetOurTeamContent/MeetOurTeamContent'
import React from 'react'

export function MeetOurTeam() {

    return (
        <>
            <MDBContainer className={'border border-0 border-danger'}>
                <MDBRow className={'border border-0 border-success mb-5'}>
                    <MeetOurTeamBanner />
                </MDBRow>

                <MDBContainer className={'border border-0 border-danger mb-5'}>
                    <MeetOurTeamContent />
                </MDBContainer>
            </MDBContainer>
        </>
    )
}